export default defineNuxtRouteMiddleware(async to => {
	const isMatchedToAnyRoute = to.matched.length > 0
	if (isMatchedToAnyRoute) return

	const isLogged = useCookie('is_logged')

	return await navigateTo({ path: isLogged ? '/panel/dashboard' : '/login' })
})
